import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { PtSelect, PtDateInput, PtTextBox } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class PublicImpacts extends Component {

    constructor(props) {
        super(props);
        const { cpModel } = this.props;
        this.state = cpModel.publicImpacts;
    }

    render() {
        const { publicImpactOptions,
                widthRestrictionsOptions,
                detourLengthOptions } = DropdownLib.getDropdowns().CP_PublicImpacts;
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                  
                    <PtDateInput label="Actual Construction Start" value={this.state.actualConsStart} disabled={this.props.disabled}
                        onChange={(date) => { this.onChangeDate(date, "actualConsStart"); }} name="actualConsStart" maxDate={new Date(2050, 5, 5)} />

                    <PtDateInput label="Actual Construction End" value={this.state.actualConsEnd}
                        onChange={(date) => { this.onChangeDate(date, "actualConsEnd"); }} name="actualConsEnd" maxDate={new Date(2050, 5, 5)} disabled={this.props.disabled} />

                    <PtSelect label="Public Impact" options={publicImpactOptions} defaultVal={this.state.publicImpact} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="publicImpact" />

                    <PtSelect label="Width Restrictions (ft)" options={widthRestrictionsOptions} defaultVal={this.state.widthRes} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="widthRes" />

                    <PtDateInput label="Impact Notice" value={this.state.impactNotice}
                        onChange={(date) => { this.onChangeDate(date, "impactNotice"); }} name="impactNotice" maxDate={new Date(2050, 5, 5)} disabled={this.props.disabled} />                   

                    <PtSelect label="Detour Length (miles)" options={detourLengthOptions} defaultVal={this.state.detourLength} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="detourLength" />

                    <PtTextBox label="Comment" value={this.state.comment} onChange={this.onInputChange} name="comment" disabled={this.props.disabled} />

                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        this.setState({ [name]: date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : null });
    }

    componentDidUpdate() {
        //console.log(this.state);
        this.props.cpModel.publicImpacts = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-planning/public-impacts.js